"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAPICallRepetitionFromError = void 0;
var _reactRedux = require("react-redux");
var _errorSelectors = require("../../store/error/errorSelectors");
var _errorActions = require("../../store/error/errorActions");
var _react = require("react");
var _services = require("../../services");
var useAPICallRepetitionFromError = function useAPICallRepetitionFromError() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var errorMessage = (0, _reactRedux.useSelector)(_errorSelectors.selectErrorMessage) || _services.locale.localeString('ErrorPage.Message');
  var previousAction = (0, _reactRedux.useSelector)(_errorSelectors.selectPreviousAPICallAction);
  var callIsInProgress = (0, _reactRedux.useSelector)(_errorSelectors.selectIsInProgress);
  var hasError = (0, _reactRedux.useSelector)(_errorSelectors.selectHasError);
  var pageToReturnTo = (0, _reactRedux.useSelector)(_errorSelectors.selectPageToReturnTo);
  var retryAPICall = function retryAPICall() {
    dispatch((0, _errorActions.setRetryInProgress)());
    dispatch(previousAction);
  };
  (0, _react.useEffect)(function () {
    if (!callIsInProgress && !hasError) {
      console.log('Change Page');
      dispatch((0, _errorActions.setApiCallRetrySuccess)(pageToReturnTo));
    }
  }, [callIsInProgress, hasError]);
  return {
    errorMessage: errorMessage,
    retryAPICall: retryAPICall,
    callIsInProgress: callIsInProgress
  };
};
exports.useAPICallRepetitionFromError = useAPICallRepetitionFromError;